import { Heart, ArrowRight } from "lucide-react";
import { useDonate } from "../context/DonateContext";

export default function GetInvolved() {
  const { open: openDonate } = useDonate();

  return (
    <section id="donate" data-testid="donate-section" className="bg-[#2C2A29] text-[#F4F1EB] relative overflow-hidden">
      <div className="absolute -top-32 -right-24 w-96 h-96 rounded-full bg-[#692128]/40 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-32 -left-24 w-96 h-96 rounded-full bg-[#C89F5D]/20 blur-3xl pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6 sm:px-10 lg:px-16 py-24 sm:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-7">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#F4F1EB]/10 border border-[#F4F1EB]/15 mb-8">
              <Heart size={14} className="text-[#C89F5D]" />
              <span className="text-xs tracking-[0.22em] uppercase text-[#F4F1EB]/85 font-semibold">
                Stand With Us
              </span>
            </div>
            <h2 className="font-serif text-5xl sm:text-6xl leading-[0.98] tracking-tight">
              Your gift becomes
              <br />
              <span className="italic text-[#C89F5D]">someone's lifeline.</span>
            </h2>
            <p className="mt-8 max-w-xl text-lg text-[#F4F1EB]/80 leading-relaxed">
              Every dollar helps us deliver groceries to a caregiver, mentorship to a teen,
              respite to a weary parent, and resources to a veteran. Stand with Guardian
              Grace today.
            </p>

            <div className="mt-10 flex flex-wrap items-center gap-4">
              <button
                onClick={openDonate}
                data-testid="main-donate-btn"
                className="group inline-flex items-center gap-2 bg-[#C89F5D] text-[#2C2A29] hover:bg-[#E0B56D] rounded-full px-9 py-4 text-sm font-semibold tracking-wide transition-all duration-300"
              >
                Donate Now
                <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
              </button>
              <a
                href="#contact"
                data-testid="contact-cta-btn"
                className="inline-flex items-center gap-2 border border-[#F4F1EB]/30 text-[#F4F1EB] hover:bg-[#F4F1EB] hover:text-[#2C2A29] rounded-full px-9 py-4 text-sm font-medium tracking-wide transition-all duration-300"
              >
                Partner With Us
              </a>
            </div>

            <p
              data-testid="tax-deductible-note"
              className="mt-8 text-xs text-[#F4F1EB]/60 max-w-xl leading-relaxed tracking-wide"
            >
              Guardian Grace Family &amp; Community Foundation is a registered 501(c)(3)
              nonprofit organization (EIN&nbsp;41-2776772). Donations are tax-deductible to
              the fullest extent allowed by law. A receipt will be emailed to you.
            </p>
          </div>

          <div className="lg:col-span-5">
            <div className="rounded-3xl bg-[#F4F1EB]/5 border border-[#F4F1EB]/15 backdrop-blur-xl p-8 md:p-10 space-y-6">
              {[
                { amount: "$25", impact: "Provides essentials for a family in need." },
                { amount: "$75", impact: "Sponsors a caregiver respite session." },
                { amount: "$150", impact: "Supports a youth mentorship month." },
                { amount: "$500", impact: "Funds outreach to ten veteran families." },
              ].map((g) => (
                <div
                  key={g.amount}
                  className="flex items-start gap-5 pb-5 border-b border-[#F4F1EB]/10 last:border-0 last:pb-0"
                >
                  <div className="font-serif text-3xl text-[#C89F5D] w-20 shrink-0">{g.amount}</div>
                  <div className="text-[#F4F1EB]/85 leading-snug pt-1">{g.impact}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
